export default {
  methods: {
    errorHandling: function(err) {
        if(err.response.status === 500) {
          this.noticeType = 'alert'
          this.noticeTitle = 'Error'
          this.noticeText = err.response.data.err
          this.isNotice = true
          setTimeout(this.isNotice = false ,5000)
          this.$parent.loading = false
        } else if(err.response.status === 422) {
          this.noticeType = 'alert'
          this.noticeTitle = 'Error'
          this.noticeText = 'invalid value'
          this.isNotice = true
          Object.keys(err.response.data.ers).filter(validate => {
            this.ers = err.response.data.ers
            this.noticeText = err.response.data.ers[validate]
          })
          setTimeout(this.isNotice = false ,5000)
          this.loading = false
        }
    },
  }
}
